var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { TrayBar_ } from '../../../../areas/TrayBar/TrayBar_';
import { DraftBottomAd } from './Bottom/DraftBottomAd';
import { CycleBarCenteredImmediateButton } from '../../../../areas/CycleBar/NextPrevious/CycleBarCenteredImmediateButton';
let DraftLayoutBottom = class DraftLayoutBottom extends React.PureComponent {
    render() {
        const { app } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(CycleBarCenteredImmediateButton, { app: app }),
            React.createElement(DraftBottomAd, { app: app }),
            React.createElement(TrayBar_, { app: app })));
    }
};
DraftLayoutBottom = __decorate([
    observer
], DraftLayoutBottom);
export { DraftLayoutBottom };
